var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "change env",
            visible: _vm.active,
            width: "300px",
            "custom-class": "d2-api-base-url-controller",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.active = $event
            }
          }
        },
        [
          _c("el-scrollbar", [
            _c(
              "div",
              { staticClass: "wrapper" },
              _vm._l(_vm.options, function(option) {
                return _c(
                  "div",
                  { key: option.value, staticClass: "item" },
                  [
                    _c(
                      "d2-button",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          size: "default",
                          type: _vm.isItemActive(option.value)
                            ? "primary"
                            : "default"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onSelect(option.value)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { flex: "main:justify cross:center" } },
                          [
                            _c(
                              "div",
                              { attrs: { flex: "dir:top cross:top" } },
                              [
                                _c("div", { staticClass: "item-name" }, [
                                  _vm._v(" " + _vm._s(option.name) + " ")
                                ]),
                                _c("div", { staticClass: "item-value" }, [
                                  _vm._v(" " + _vm._s(option.value) + " ")
                                ])
                              ]
                            ),
                            _vm.isItemActive(option.value)
                              ? _c(
                                  "span",
                                  [
                                    _c("d2-icon", {
                                      staticClass: "item-icon",
                                      attrs: { name: "check-circle" }
                                    })
                                  ],
                                  1
                                )
                              : option.type === "custom"
                              ? _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.onRemove(option.value)
                                      }
                                    }
                                  },
                                  [
                                    _c("d2-icon", {
                                      staticClass: "item-icon",
                                      attrs: { name: "close" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              }),
              0
            )
          ]),
          _c("el-divider", [_vm._v("or")]),
          _c(
            "div",
            { attrs: { flex: "main:justify cross:center" } },
            [
              _c("el-input", {
                staticClass: "d2-mr-5",
                attrs: { size: "default" },
                model: {
                  value: _vm.custom,
                  callback: function($$v) {
                    _vm.custom = $$v
                  },
                  expression: "custom"
                }
              }),
              _c("d2-button", {
                attrs: {
                  size: "default",
                  disabled: _vm.custom.length === 0,
                  label: "ok"
                },
                on: {
                  click: function($event) {
                    return _vm.onSelect(_vm.custom)
                  }
                }
              })
            ],
            1
          ),
          _c("el-divider"),
          _c("d2-button", {
            staticStyle: { width: "100%" },
            attrs: { size: "default", type: "primary", label: "sumit" },
            on: { click: _vm.onClose }
          })
        ],
        1
      ),
      _c("span", { on: { click: _vm.onOpen } }, [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }